import { AppTreeSide } from 'components'
import { loadRegionTree, loadStreamNodeTreeItems, findTreeItemData } from 'utils/tree'
import { VideoPlayerManager } from 'utils/video-player-manager'
import ModifyVideoPatrol from './modifyVideoPatrol'
import ssoLoginMixin from '@/mixins/sso-login-mixin.js' // 引入mixin文件
import convertorMixin from '@/mixins/convertor-mixin.js' // 引入mixin文件
import typeImageMixin from '@/mixins/type-image-mixin.js' // 引入mixin文件
import {getRegionList} from '@/api/get-data.js'
import {browserFullScreen} from 'utils/bom.js'

export default {
  name: 'LiveVideo',
  data() {
    return {
      // 侧边栏打开标志
      treeSideBarOpen: true,
      // 底部栏打开标志
      footerOpen: true,
      // 树数据
      treeData: [],
      // 树节点已加载的区域id数组
      treeNodeLoadedRegionIds: [],
      treeExpandedKeys: [], // 默认展开树节点key
      // 查询条件
      treeQueryParams: {
        pageNum: 1,
        pageSize: 1000
      },
      // 默认树属性
      defaultTreeProps: {
        label: 'name' // name字段作为label
      },
      // 树节点显示过滤
      treeNodeFilter: '',
      filteredTreeData: [],
      // 视频控制区域
      controlTabsOpen: true, // 控制区域是否显示
      activeTabName: '0', // 活动控制页面索引
      // 云台控制
      hSpeed: 5,
      vSpeed: 5,
      // 预置点控制
      presetInfoTableData: [],
      presetInfoTableTotalRow: 0,
      persetInfoTableCurrentId: 0,
      persetInfoTableCurrentPresetNum: 0,
      presetInfoTableQueryParams: {
        nodeId: 0,
        pageNum: 1,
        pageSize: 5
      },
      // 遮罩层
      presetInfoLoading: false,
      // 图像参数
      videoParam: {
        ld: 127,
        db: 127,
        bh: 127,
        sd: 127
      },
      // 视频播放器管理器
      tileVisible: true,
      playProtocol: this.$globalConfig.playProtocol, // 播放协议，0-rtmp,1-hls,2-http-flv,3-ws-flv
      playerManager: null,
      scheme: 'none',
      // 视频轮巡
      videoPatrolModalOpen: false,
      videoPatrolActive: false,
      videoPatrolStreamNodes: [],
      videoPatrolTimer: null,
      autoPatrol: false
    }
  },
  components: {
    AppTreeSide,
    ModifyVideoPatrol
  },
  mixins: [
    ssoLoginMixin,
    convertorMixin,
    typeImageMixin
  ],
  computed: {
    players: function () {
      return this.playerManager.players
    },
    currentVideoPlayerId: function () {
      return this.playerManager.currentPlayerId
    },
    currentStreamNodeId: function () {
      return this.playerManager.currentStreamNodeId
    },
    isSingle: function () {
      return this.playerManager.isSingle()
    }
  },
  watch: {
    // 根据名称筛选节点
    treeNodeFilter(val) {
      this.$refs.tree.filter(val.trim())
    }
  },
  created() {
    // 显示或隐藏树侧边栏
    // this.treeSideBarOpen = this.$globalConfig.treeSideBarOpen
    if (this.$route.query.treeSideBarOpen) {
      this.treeSideBarOpen = this.$route.query.treeSideBarOpen === '1' || this.$route.query.treeSideBarOpen === 'true'
    }
    // 控制区域是否显示
    if (this.$route.query.controlTabsOpen) {
      this.controlTabsOpen = this.$route.query.controlTabsOpen === '1' || this.$route.query.controlTabsOpen === 'true'
    }
    // 自动播放方案
    this.scheme = this.$globalConfig.scheme
    if (this.$route.query.scheme) {
      this.scheme = this.$route.query.scheme
    }

    // 创建播放器管理器
    this.playerManager = new VideoPlayerManager()
  },
  mounted() {
    if (!this.treeSideBarOpen) { // 隐藏树侧边栏
      this.fullScreen()
    }

    // 单点登录（如url包含code和uiapTpye参数则启用单点登录）
    this.ssoLogin(this.$route.query.code, this.$route.query.uiapType).then(res => {
      // 获取区域列表
      this.getRegionList2()
    })
  },
  methods: {
    // 显示或隐藏树侧边栏
    toggleTreeSideBar() {
      this.treeSideBarOpen = !this.treeSideBarOpen
    },
    toggleFooter() {
      this.footerOpen = !this.footerOpen
    },
    // 查询区域列表
    getRegionList2() {
      getRegionList(this.$globalConfig.regionGettingFilterMode, () => {
        this.treeData = []
        this.treeData = loadRegionTree(this.$globalData.regions, this.treeData, true)
        this.$nextTick(() => {
          if (this.treeData.length > 0) {
            // 查询顶层区域下的视频节点列表
            this.getStreamNodeList(this.treeData[0].id)
            // 默认展开根节点
            this.treeExpandedKeys = [this.treeData[0].key]
            // 设置根节点或根节点的首个子节点为当前节点
            let currentKey = null
            if (this.$globalConfig.currentRegionSynchEnabled && this.$store.getters.appCurrentRegionKey) { // 区域同步选择启用
              currentKey = this.$store.getters.appCurrentRegionKey
            } else {
              if (this.$globalConfig.defaultCurrentTreeNode === 0) { // 根节点
                currentKey = this.treeData[0].key
              } else if (this.$globalConfig.defaultCurrentTreeNode === 1) { // 根节点的首个子节点
                currentKey = this.treeData[0].children.length > 0 ? this.treeData[0].children[0].key : this.treeData[0].key
              }
            }
            if (currentKey) {
              this.$refs.tree.setCurrentKey(currentKey)
              // 单击当前节点
              this.handleTreeNodeClick(this.$refs.tree.getCurrentNode())
            }
            // 自动打开视频
            if (this.$store.getters.userToken !== '') {
              // 自动播放方案
              // scheme=none
              // scheme=histroyVideo
              // scheme=region&regionId=1&regionCode=abcd&maxNode=4
              // scheme=userCollection&collectionId=1
              // scheme=scene&sceneId=1&sceneCode=abcd
              // scheme=nodeSet&nodeIds=1-2-3-4-5
              if (this.scheme === '' || this.scheme === 'none') {
              } else if (this.scheme === 'histroyVideo') {
                this.startHistoryVideos()
              } else if (this.scheme === 'region') {
                this.startVideosByRegionIdOrCode(this.$route.query.regionId, this.$route.query.regionCode)
              } else if (this.scheme === 'scene') {
                this.startVideosBySceneIdOrCode(this.$route.query.sceneId, this.$route.query.sceneCode)
              } else if (this.scheme === 'userCollection') {
                this.startVideosByUserCollectionId(this.$route.query.collectionId)
              } else if (this.scheme === 'nodeSet') {
              } else {
              }
            }
          }
        })
      })
    },
    // 查询视频节点列表
    getStreamNodeList(regionId) {
      // 检测该区域下视频节点是否已加载，防止重复加载
      if (this.treeNodeLoadedRegionIds.indexOf(regionId) !== -1) {
        return
      }

      this.$http(this.$api.streamNodeList, {
        regionId: regionId,
        streamServerInfoRequired: 1, // 需获取流媒体服务信息
        pageNum: 1,
        pageSize: 1000
      }).then(
        res => {
          if (res.code === 200) {
            // 检测该区域下视频节点是否已加载，防止重复加载
            if (this.treeNodeLoadedRegionIds.indexOf(regionId) !== -1) {
              return
            }
            if (res.data.length) {
              this.treeData = loadStreamNodeTreeItems(res.data, this.treeData)
              if (this.$refs.tree.getCurrentKey() && this.treeExpandedKeys.indexOf(this.$refs.tree.getCurrentKey()) === -1) {
                this.treeExpandedKeys = []
                this.treeExpandedKeys.push(this.$refs.tree.getCurrentKey()) // 展开父区域
              }
            }
            this.treeNodeLoadedRegionIds.push(regionId)
          }
        }).catch(err => {
        console.log(err)
      })
    },
    // 查询预置点列表
    getPresetInfoList() {
      this.presetInfoLoading = true
      this.$http(this.$api.presetInfoList, this.presetInfoTableQueryParams).then(
        res => {
          if (res.code === 200) {
            this.presetInfoTableData = res.data
            this.presetInfoTableTotalRow = res.page.totalRow
            if (res.data.length) {
              this.$refs.presetInfoTable.setCurrentRow(res.data[0]) // 选中首行
              this.persetInfoTableCurrentId = res.data[0].id
              this.persetInfoTableCurrentPresetNum = res.data[0].presetNum
            } else {
              this.persetInfoTableCurrentId = 0
              this.persetInfoTableCurrentPresetNum = 0
            }
          }
          this.presetInfoLoading = false
        }).catch(err => {
        console.log(err)
        this.presetInfoLoading = false
      })
    },
    // 过滤树节点
    filterTreeNode(value, data) {
      if (!value) return true
      return data.name.indexOf(value) !== -1
    },
    // 单击树节点
    handleTreeNodeClick(obj) {
      if (!obj) {
        return
      }

      if (obj.type === 'region') {
        this.getStreamNodeList(obj.id)

        if (this.$globalConfig.currentRegionSynchEnabled) { // 当前区域同步启用
          this.$store.commit('app/SET_CURRENT_REGION_KEY', obj.key) // 更新当前区域key
        }
      } else if (obj.type === 'streamNode' && this.presetInfoTableQueryParams.nodeId !== obj.id) {
        // 选中窗口
        this.selectVideoPlayerByStreamNodeId(obj.id)
        // 查询预置点列表
        this.presetInfoTableQueryParams.nodeId = obj.id
        this.presetInfoTableQueryParams.pageNum = 1
        this.getPresetInfoList()
      }
    },
    // 右击树节点
    handleTreeNodeContextMenu(e, obj, node, self) {
      if (obj.type === 'streamNode') {
        if (obj.workState === 0) {
          this.startVideo(obj.id, obj.name, obj.streamOpenMode, obj.streamServerIp, obj.streamServerPort3) // 端口3为rtmp/hls/flv端口
        } else {
          this.stopVideo(obj.id)
        }
      }
    },
    // 更新树节点播放状态
    updateTreeNodePlayState(streamNodeId, workState) {
      let treeItemData = findTreeItemData(streamNodeId, 'streamNode', this.treeData)
      if (treeItemData) {
        treeItemData.workState = workState
        if (this.$refs.tree && this.$refs.tree.root) { // 数据更新后必须手动才能刷新树视图
          this.$refs.tree.root.loaded = false
          this.$refs.tree.root.loadData()
        }
      }
    },
    // 打开视频
    startVideo(id, name, streamOpenMode, streamServerIp, streamServerPort) {
      if (this.playerManager.getInactiveVideoPlayerCount() === 0) {
        this.$messagebox.confirm('没有可用的视频窗口，请先关闭窗口后再尝试', '提示', {
          confirmButtonText: '知道了',
          showCancelButton: false,
          type: 'warning'
        })
        return false
      }
      this.updateTreeNodePlayState(id, 1)
      this.playerManager.openVideoPlayer(id, name, streamOpenMode, false, this.$store.getters.userToken, this.playProtocol, streamServerIp, streamServerPort)
      // 记录视频节点数组
      this.$store.commit('liveVideo/SET_ACTIVE_STREAM_NODES', this.playerManager.streamNodes)
      return true
    },
    // 打开多个视频
    startVideos(streamNodes) {
      let layout = { name: '单画面', count: 1 }
      if (streamNodes.length > 1) {
        layout = { name: '四画面', count: 4 }
      }
      this.playerManager.switchLayout(layout)

      // 调阅实时视频
      let streamNodes2 = []
      for (let i = 0; i < streamNodes.length; ++i) {
        if (!streamNodes[i]) {
          continue
        }
        streamNodes[i].audioEnabled = false
        streamNodes[i].accessToken = this.$store.getters.userToken
        streamNodes[i].playProtocol = this.playProtocol
        this.updateTreeNodePlayState(streamNodes[i].id, 1)
        streamNodes2.push(streamNodes[i])
      }
      this.playerManager.openVideoPlayers(streamNodes2)
    },
    // 打开上一次的打开视频
    startHistoryVideos() {
      this.startVideos(this.$store.getters.liveVideoActiveStreamNodes)
    },
    // 根据区域id或code打开视频
    startVideosByRegionIdOrCode(id, code) {
      if (id != null) {
        this.$http(this.$api.streamNodeList, {
          regionId: id,
          streamServerInfoRequired: 1, // 需获取流媒体服务信息
          pageNum: 1,
          pageSize: 16
        }).then(
          res => {
            if (res.code === 200) {
              if (res.data.length) {
                this.startVideos(res.data)
              }
            }
          }
        )
      } else if (code != null) {
        this.$http(this.$api.streamNodeList, {
          regionId: 0,
          regionCode: code,
          streamServerInfoRequired: 1, // 需获取流媒体服务信息
          pageNum: 1,
          pageSize: 16
        }).then(
          res => {
            if (res.code === 200) {
              if (res.data.length) {
                this.startVideos(res.data)
              }
            }
          }
        )
      }
    },
    // 根据场景id或code打开视频
    startVideosBySceneIdOrCode(id, code) {
      if (id != null) {
        this.$http(this.$api.sceneStreamNodeList, {
          sceneId: id,
          streamServerInfoRequired: 1, // 需获取流媒体服务信息
          pageNum: 1,
          pageSize: 16
        }).then(
          res => {
            if (res.code === 200) {
              if (res.data.length) {
                this.startVideos(res.data)
              }
            }
          }
        )
      } else if (code != null) {
        this.$http(this.$api.sceneStreamNodeList, {
          sceneId: 0,
          sceneCode: code,
          streamServerInfoRequired: 1, // 需获取流媒体服务信息
          pageNum: 1,
          pageSize: 16
        }).then(
          res => {
            if (res.code === 200) {
              if (res.data.length) {
                this.startVideos(res.data)
              }
            }
          }
        )
      }
    },
    // 根据用户收藏id打开视频
    startVideosByUserCollectionId(id) {
      if (id != null) {
        this.$http(this.$api.userCollectionStreamNodeList, {
          userCollectionId: id,
          streamServerInfoRequired: 1, // 需获取流媒体服务信息
          pageNum: 1,
          pageSize: 16
        }).then(
          res => {
            if (res.code === 200) {
              if (res.data.length) {
                this.startVideos(res.data)
              }
            }
          }
        )
      }
    },
    // 选中视频播放器
    selectVideoPlayer(videoPlayer) {
      this.playerManager.select(videoPlayer)
      // 选中视频树节点
      this.$refs.tree.setCurrentKey('streamNode' + videoPlayer.streamNodeId)
      this.handleTreeNodeClick(this.$refs.tree.getCurrentNode())
    },
    // 选中视频播放器
    selectVideoPlayerByStreamNodeId(streamNodeId) {
      this.playerManager.selectByStreamNodeId(streamNodeId)
    },
    // 单画面
    singleLayout() {
      // 暂停播放
      for (let i = 0; i < this.playerManager.players.length; ++i) {
        if (this.playerManager.players[i].active && this.playerManager.currentPlayerId !== this.playerManager.players[i].id) {
          this.playerManager.players[i].pausePlay()
        }
      }
      this.playerManager.switchLayout({ name: '单画面', count: 1 })
      this.$store.commit('liveVideo/SET_LAYOUT', this.playerManager.currentLayout) // 记录布局
    },
    // 四画面
    fourLayout() {
      this.playerManager.switchLayout({ name: '四画面', count: 4 })
      // 恢复播放
      for (let i = 0; i < this.playerManager.players.length; ++i) {
        if (this.playerManager.players[i].paused) {
          this.playerManager.players[i].resumePlay()
        }
      }
      this.$store.commit('liveVideo/SET_LAYOUT', this.playerManager.currentLayout) // 记录布局
    },
    // 抓图
    capturePictureJpeg() {
      if (this.playerManager.currentPlayer === null) {
        this.$messagebox.confirm('请先打开当前选中摄像机视频！', '提示', {
          confirmButtonText: '知道了',
          showCancelButton: false,
          type: 'warning'
        })
      } else {
        let params = {
          accessToken: this.$store.getters.userToken,
          nodeId: this.playerManager.currentStreamNodeId,
          streamOpenMode: Number(this.playerManager.currentPlayer.streamOpenMode),
          pictureFormat: 1
        }
        this.$http(this.$api.capturePicture, params).then(
          res => {
            if (res.code === 200) {
              window.open(res.data.pictureUrl)
            }
          }
        )
      }
    },
    // 关闭指定视频
    stopVideo(streamNodeId) {
      this.playerManager.closeVideoPlayer(streamNodeId)
      this.updateTreeNodePlayState(streamNodeId, 0)
      // 记录视频节点数组
      this.$store.commit('liveVideo/SET_ACTIVE_STREAM_NODES', this.playerManager.streamNodes)
    },
    // 关闭全部视频
    stopAllVideo() {
      this.playerManager.players.forEach((item, index) => {
        this.updateTreeNodePlayState(item.streamNodeId, 0)
      })
      this.playerManager.closeAll()
      // 记录视频节点数组
      this.$store.commit('liveVideo/SET_ACTIVE_STREAM_NODES', this.playerManager.streamNodes)
    },
    // 是否显示标题
    switchTitleVisible() {
      this.tileVisible = !this.tileVisible
      for (let i = 0; i < this.playerManager.players.length; ++i) {
        if (this.tileVisible) {
          this.$refs.videoPlayerContainer[i].style.height = 'calc(100% - 33px)'
          this.$refs.videoPlayerContainer[i].style.marginTop = '0'
        } else {
          this.$refs.videoPlayerContainer[i].style.height = 'calc(100% - 10px)'
          this.$refs.videoPlayerContainer[i].style.marginTop = '5px'
        }
      }
    },
    // 全屏
    fullScreen() {
      this.treeSideBarOpen = false
      this.footerOpen = false
      if (this.tileVisible) {
        this.switchTitleVisible()
      }
    },
    // 恢复正常
    retsoreNormal() {
      this.treeSideBarOpen = true
      this.footerOpen = true
      if (!this.tileVisible) {
        this.switchTitleVisible()
      }
    },
    // 视频浏览器全屏
    videoBrowserFullScreen() {
      browserFullScreen(this.$refs.videoList)
    },
    // 云台控制
    ptzControl(ptzCmd) {
      if (this.playerManager.currentPlayer === null) {
        this.$messagebox.confirm('请先打开当前选中摄像机视频！', '提示', {
          confirmButtonText: '知道了',
          showCancelButton: false,
          type: 'warning'
        })
      } else {
        let params = {
          accessToken: this.$store.getters.userToken,
          nodeId: this.playerManager.currentStreamNodeId,
          ptzCmd: ptzCmd,
          hSpeed: this.hSpeed,
          vSpeed: this.vSpeed
        }
        this.$http(this.$api.ptzControl, params).then(
          res => {
            if (res.code === 200) {
              console.log(res.data)
            }
          }
        )
      }
    },
    // 预置点控制
    presetControl(presetCmd) {
      if (this.playerManager.currentPlayer === null) {
        this.$messagebox.confirm('请先打开当前选中摄像机视频！', '提示', {
          confirmButtonText: '知道了',
          showCancelButton: false,
          type: 'warning'
        })
      } else {
        if (this.presetInfoTableData.length === 0) return

        let params = {
          nodeId: this.playerManager.currentStreamNodeId,
          presetCmd: presetCmd,
          presetId: 0,
          presetNum: this.persetInfoTableCurrentPresetNum
        }
        this.$http(this.$api.presetControl, params).then(
          res => {
            if (res.code === 200) {
              console.log(res.data)
            }
          }
        )
      }
    },
    // 预置点表格当前记录改变
    handlePresetInfoTableCurrentChange(currentRow, oldCurrentRow) {
      if (currentRow == null) {
        return
      }

      this.persetInfoTableCurrentId = currentRow.id
      this.persetInfoTableCurrentPresetNum = currentRow.presetNum
    },
    // 预置点表格分页
    handlePresetInfoCurrentPageChange(val) {
      this.presetInfoTableQueryParams.pageNum = val
      this.getPresetInfoList()
    },
    // 修改视频轮巡
    handleModifyVideoPatrol() {
      this.videoPatrolModalOpen = true
    },
    // 开始轮巡
    handleStartVideoPatrol(data) {
      this.videoPatrolModalOpen = false
      this.videoPatrolStreamNodes = []
      this.videoPatrolStreamNodes = data.checkedStreamNodes
      this.videoPatrolActive = true

      clearInterval(this.videoPatrolTimer)
      this.patrolStreamNodeIndex = 0
      this.patrolStreamNodeCount = this.playerManager.currentLayout.count
      // 先执行一次
      let e = {}
      this.handleVideoPatrolTimer(e)
      this.videoPatrolTimer = setInterval(this.handleVideoPatrolTimer, data.patrolInterval * 1000)
      console.log('开始轮巡')
    },
    // 停止轮巡
    handleStopVideoPatrol() {
      clearInterval(this.videoPatrolTimer)
      this.videoPatrolTimer = null
      this.videoPatrolActive = false
      console.log('停止轮巡')
    },
    //
    handleModalCancel() {
      this.videoPatrolModalOpen = false
    },
    // 执行轮巡
    handleVideoPatrolTimer(e) {
      if (!this.videoPatrolActive) {
        return
      }
      // 轮巡视频节点数量少于布局数
      if (this.patrolStreamNodeIndex + this.patrolStreamNodeCount > this.videoPatrolStreamNodes.length) {
        this.patrolStreamNodeCount = this.videoPatrolStreamNodes.length - this.patrolStreamNodeIndex
      }
      // 分别调阅实时视频
      this.stopAllVideo()
      setTimeout(() => {
        let streamNodes = []
        for (let i = this.patrolStreamNodeIndex; i < this.patrolStreamNodeIndex + this.patrolStreamNodeCount; ++i) {
          this.videoPatrolStreamNodes[i].audioEnabled = false
          this.videoPatrolStreamNodes[i].accessToken = this.$store.getters.userToken
          this.videoPatrolStreamNodes[i].playProtocol = this.playProtocol
          streamNodes.push(this.videoPatrolStreamNodes[i])
          this.updateTreeNodePlayState(this.videoPatrolStreamNodes[i].id, 1)
        }
        this.playerManager.openVideoPlayers(streamNodes)
        console.log('开始下一轮轮巡')

        // 记录视频节点数组
        this.$store.commit('liveVideo/SET_ACTIVE_STREAM_NODES', this.playerManager.streamNodes)

        this.patrolStreamNodeIndex += this.patrolStreamNodeCount
        // 已经到达轮巡视频节点数组末尾，从头开始
        if (this.patrolStreamNodeIndex >= this.videoPatrolStreamNodes.length) {
          this.patrolStreamNodeIndex = 0
          this.patrolStreamNodeCount = this.playerManager.currentLayout.count
        }
      }, 5000)
    }
  }
}



// WEBPACK FOOTER //
// ./src/views/monitoring/liveVideo/LiveVideo.js